export default __webpack_public_path__ + "static/media/bod.42d73025.svg";